import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'esl-tag',
  templateUrl: './esl-tag.component.html',
  styleUrls: ['./esl-tag.component.scss']
})
export class EslTagComponent implements OnInit {

  @Input() label!: string;
  @Input() removable: boolean = false;
  @Input() disabled: boolean = false;
  @Input() icon!: string;
  @Input() forceSmallScreenMode: boolean = false;
  @Input() clickable: boolean = false;
  @Input() visible: boolean = true;
  @Output() removed = new EventEmitter();
  @Input() color: string = '';
  @Input() bgColor: string = '';
  @Input() static: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  remove() {
    if(this.disabled) {
      return;
    }
    this.visible = false;
    this.removed.emit()
  }

}
